var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClubIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5767_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53151 12.5334H17.4648V14.5867H18.5315V11.4667H12.5315V9.33337H11.4648V11.4667H5.46484V14.5867H6.53151V12.5334Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 15.3334H2.66536C1.92898 15.3334 1.33203 15.9303 1.33203 16.6667V20.6667C1.33203 21.4031 1.92898 22 2.66536 22H9.33203C10.0684 22 10.6654 21.4031 10.6654 20.6667V16.6667C10.6654 15.9303 10.0684 15.3334 9.33203 15.3334Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.332 15.3334H14.6654C13.929 15.3334 13.332 15.9303 13.332 16.6667V20.6667C13.332 21.4031 13.929 22 14.6654 22H21.332C22.0684 22 22.6654 21.4031 22.6654 20.6667V16.6667C22.6654 15.9303 22.0684 15.3334 21.332 15.3334Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.332 2H8.66536C7.92898 2 7.33203 2.59695 7.33203 3.33333V7.33333C7.33203 8.06971 7.92898 8.66667 8.66536 8.66667H15.332C16.0684 8.66667 16.6654 8.06971 16.6654 7.33333V3.33333C16.6654 2.59695 16.0684 2 15.332 2Z",
    fill: "#00ADEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5767_1050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubIcon);
export default __webpack_public_path__ + "static/media/clubIcon.9f359c9696f68352afa46cd8bbd56898.svg";
export { ForwardRef as ReactComponent };